module.exports = __webpack_public_path__ + "img/mini-avatar2.6bcb15b8.png";